import React, { useEffect, useState } from 'react';
import { FormField, MaskedInput, InputAdornment, InputGroup } from '@cian/ui-kit';
import { useBaseField } from '../../BaseField';
import { IField } from '../../../types/calculator';
import { getFieldPlaceholder } from '../../../utils';
import { MAX_VALUE_IN_MONTH } from '../../../constants/maxValueInMonth';

const convertYearsInMonths = (year: number) => year * 12;
const isNumberValue = (val: number | undefined): val is number => Number.isInteger(val);

export const YearMonthField: React.FC<IField> = props => {
  const {
    field: { onChange, value, name },
    fieldState,
  } = useBaseField(props);

  const [year, setYear] = useState<number | undefined>(undefined);
  const [month, setMonth] = useState<number | undefined>(undefined);

  useEffect(() => {
    setYear(value ? Math.floor(Number(value) / 12) : undefined);
    setMonth(value ? Number(value) % 12 : undefined);
  }, [value]);

  const changeValue = (year: number | undefined, month: number | undefined) => {
    setYear(year);
    setMonth(month);

    if (isNumberValue(year) && isNumberValue(month)) {
      onChange(convertYearsInMonths(year) + month);
    } else {
      const yearValue = year ? convertYearsInMonths(year) : undefined;
      const monthValue = month || undefined;

      onChange(yearValue || monthValue || null);
    }
  };
  const onChangeYear = (value: string) => {
    changeValue(value ? Number(value) : undefined, month);
  };
  const onChangeMonth = (value: string) => {
    changeValue(year, value ? Number(value) : undefined);
  };

  const yearError =
    year && convertYearsInMonths(year) > MAX_VALUE_IN_MONTH ? `${props.label} не может превышать 60 лет` : undefined;
  const errorMessage = fieldState.isDirty || fieldState.invalid ? yearError || fieldState.error : undefined;

  return (
    <FormField label={props.label} errorMessage={errorMessage} required={!!props.validation?.required} withoutMargin>
      <InputGroup spliced>
        <MaskedInput
          data-testid={`form-date-input-year ${name}`}
          value={isNumberValue(year) ? String(year) : ''}
          onChange={onChangeYear}
          invalid={Boolean(errorMessage)}
          rightAdornment={<InputAdornment>{props.rightAdornment?.[0]}</InputAdornment>}
          placeholder={getFieldPlaceholder(props.placeholder, 0)}
          size="M"
          mask="00"
          lazy
        />
        <MaskedInput
          data-testid={`form-date-input-month ${name}`}
          value={isNumberValue(month) ? String(month) : ''}
          onChange={onChangeMonth}
          invalid={Boolean(errorMessage)}
          rightAdornment={<InputAdornment>{props.rightAdornment?.[1]}</InputAdornment>}
          placeholder={getFieldPlaceholder(props.placeholder, 1)}
          size="M"
          mask="00"
          lazy
        />
      </InputGroup>
    </FormField>
  );
};

YearMonthField.displayName = 'YearMonthField';
